import React from 'react'

const MovedToNextRoundIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.486 0.001 0 4.487 0 10.001C0 15.515 4.486 20.001 10.001 20.001C15.514 20.001 20 15.515 20.001 10.001C20.002 4.487 15.515 0.001 10 0ZM10.001 18.001C5.589 18.001 2 14.412 2 10.001C2 5.59 5.589 2.001 10 2C14.412 2.001 18.001 5.59 18.001 10.001C18 14.412 14.411 18.001 10.001 18.001Z"
        fill="#0FB680"
      />
      <path
        d="M10.001 9.003H6.00098V11.003H10.001V14.009L14.006 10.004L10.001 6V9.003Z"
        fill="#0FB680"
      />
    </svg>
  )
}

export default MovedToNextRoundIcon
